<template>
  <sidebar class="kitty-sidebar">
    <sidebar-list>
      <sidebar-item
        v-if="canPerform('authcore.users.list')"
        icon="fa-user"
        title="Users"
        :to="{ name: 'UserList' }"
        :active="subIsActive('/users')"
        exact />
      <sidebar-item
        v-if="canPerform('authcore.roles.list')"
        icon="fa-users-cog"
        title="Roles"
        :to="{ name: 'RoleList' }"
        :active="subIsActive('/roles')"
        exact />
      <sidebar-item
        v-if="canPerform('authcore.auditLogs.list')"
        icon="fa-user"
        title="Logs"
        :to="{ name: 'LogList' }"
        :active="subIsActive('/logs')"
        exact />
      <sidebar-item
        icon="fa-cogs"
        title="Settings">
        <sidebar-list>
          <sidebar-item
            v-if="canPerform('authcore.templates.list')"
            title="Email"
            :to="{ name: 'EmailTemplateSettings' }"
            :active="subIsActive('/settings/email')"
            exact />
          <sidebar-item
            v-if="canPerform('authcore.templates.list')"
            title="SMS"
            :to="{ name: 'SMSTemplateSettings' }"
            :active="subIsActive('/settings/sms')"
            exact />
        </sidebar-list>
      </sidebar-item>

    </sidebar-list>
  </sidebar>
</template>

<script>
export default {
  name: 'ManagementSidebar',
  components: {},

  props: {},

  data: function () {
    return {}
  },
  computed: {},

  watch: {},

  created () {},
  mounted () {},
  updated () {},
  destroyed () {},

  methods: {
    // For parent `sidebar-item` require this function to check the path to activate the visible and active states
    // Check if the sub item href includes the input result
    subIsActive (input) {
      const pathArr = this.$route.path.replace('/management', '')
      return pathArr.includes(input)
    }
  }
}
</script>
